<template>
    <div v-if="commissions.length">
        <b-table
            :fields="tableHeader"
            :items="commissions"
        >
            <template v-slot:cell(actions)="{item}">
                <div class="d-flex align-items-center">
                    <button
                        @click="showEditModal(item.id)"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title=""
                        data-bs-original-title="Edit profile">
                        <i class="align-middle fas fa-fw fa-pen"></i>
                    </button>
                    <div data-bs-toggle="tooltip" data-bs-placement="top" title="Delete">
                        <button
                            type="button"
                            class="btn mb-1 btn-danger js-open-confirmation"
                            @click="deleteCommission(item.id)"
                        >Delete
                        </button>
                    </div>
                </div>
            </template>
        </b-table>
        <b-modal
            no-enforce-focus
            id="modal-edit-commissions"
            centered
        >
            <div class="row mb-12">
                <label for="resume_date" class="main-text-bold pb-3 pt-3 px-0">Edit commission</label>
                <input
                    v-model="commission"
                    name="resume_date"
                    type="number"
                    step="0.01"
                    required
                    class="form-control main-text-input js-form-element datepicker-bid mb-1">
            </div>
            <template #modal-footer>
                <div class="w-100">
                    <b-button
                        :disabled="loadData"
                        variant="primary"
                        size="sm"
                        class="text-align-end"
                        @click="updateCommission"
                    >
                        Submit
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        commissions: {
            type: Array
        },
        role: {
            type: String
        }
    },
    data: () => ({
        tableHeader: ['name', 'percent', 'actions'],
        commission: '',
        commissionId: null,
        loadData: false
    }),
    methods: {
        showEditModal(id) {
            this.commissionId = id
            this.$bvModal.show('modal-edit-commissions')
        },
        async deleteCommission(id) {
            try {
                await axios.delete(`/admin/delete-commission/${id}/${this.role}`)
                window.location.reload()
            } catch (e) {
                console.log(e)
            }
        },
        async updateCommission() {
            this.loadData = true
            try {
                await axios.put(`/admin/edit-commission/${this.commissionId}/${this.role}`, {
                    percent: this.commission
                })
                window.location.reload()
            } catch (e) {
                this.loadData = false
                console.log(e)
            }
        }
    }
}
</script>
